import { InvoiceException } from '@/domain/stripe/invoice/repository/contract/exception/InvoiceException'

export class CustomerNotFoundException extends InvoiceException {

}